export const FETCH_CTL_RULES = "FETCH_CTL_RULES";
export const FETCH_CTL_RULES_SUCCESS = "FETCH_CTL_RULES_SUCCESS";
export const FETCH_CTL_RULES_FAILED = "FETCH_CTL_RULES_FAILED";
